import { render, staticRenderFns } from "./AppRating.vue?vue&type=template&id=2e1406b2&scoped=true"
import script from "./AppRating.vue?vue&type=script&lang=js"
export * from "./AppRating.vue?vue&type=script&lang=js"
import style0 from "./AppRating.vue?vue&type=style&index=0&id=2e1406b2&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1406b2",
  null
  
)

export default component.exports